export const WAREHOUSE_OPTIONS = [
  { label: "Kho Trảng Bom", value: "TL" },
  { label: "Kho Long Thành", value: "LT" },
  { label: "Kho Cường Thịnh", value: "CT" },
]